<div class="delete-confirm-popup">
  <div class="text-color-secondary px-2 pt-5 pb-2" *ngIf="!!confirmMessage">
    {{ confirmMessage | translate }}?
    <!-- <span class="item-name" *ngIf="itemName">{{ itemName }}</span
    >? -->
  </div>
  <app-base-textarea
    *ngIf="showReason"
    placeholder="PLEASE_STATE_YOUR_REASON_HERE"
    [fieldControl]="fieldControl"
    [hideLengthLimit]="hideLengthCount"
  >
  </app-base-textarea>
  <div class="btn-group flex gap-2">
    <app-base-button label="DELETE" (click)="closeDialog('submit')">
    </app-base-button>
    <app-base-button
      [outlined]="true"
      ngClass="mr-2"
      label="CANCEL"
      (click)="closeDialog('cancel')"
    >
    </app-base-button>
  </div>
</div>
